define(['underscore',
        'angular',
        'text!./templates/mfp-create-contact.html'],
    (_, angular, templateStr) => {

        return ['LocaleService', 'BaslerCommonService', 'BaslerContactTypeGenderSelector', 'MFP_FAVOURITE_COUNTRY_CODES_FOR_NATIONALITY', // NOSONAR
            function (LocaleService, BaslerCommonService, BaslerContactTypeGenderSelector, MFP_FAVOURITE_COUNTRY_CODES_FOR_NATIONALITY) { // NOSONAR
                return {
                    restrict: 'E',
                    scope: {
                        contact: '=contactView',
                        isAccountHolder: '=',
                        readonly: '=',
                        allowTypeChange: '=',
                    },
                    template: templateStr,
                    link: function ($scope) {

                        $scope.showDataInputFields = showDataInputFields;
                        $scope.isPerson = isPerson;


                        // determine if company option is shown and / or if it is read only
                        $scope.showGenderTypeSelector = $scope.allowTypeChange || $scope.contact.isCompany.value;
                        $scope.genderTypeSelectorReadonly = !$scope.allowTypeChange && $scope.contact.isCompany.value;
                        if ($scope.showGenderTypeSelector) {
                            $scope.contactTypeGender = BaslerContactTypeGenderSelector.createContactTypeGenderModelView($scope.contact);
                        }

                        // Configuration of the max and min date for the first registration date picker
                        const yearsToRestMaxDateOfBirth = 15;
                        const yearsToRestMinDateOfBirth = 100;
                        $scope.maxDateOfBirth = new Date();
                        $scope.maxDateOfBirth.setUTCFullYear($scope.maxDateOfBirth.getUTCFullYear() - yearsToRestMaxDateOfBirth);
                        $scope.minDateOfBirth = new Date();
                        $scope.minDateOfBirth.setUTCFullYear($scope.minDateOfBirth.getUTCFullYear() - yearsToRestMinDateOfBirth);

                        // Setting the countries to display as buttons and as favourites in the nationality chooser
                        $scope.buttonCountriesForNationality = MFP_FAVOURITE_COUNTRY_CODES_FOR_NATIONALITY.BUTTON_COUNTRY_CODES;
                        $scope.favouriteCountriesForNationality = MFP_FAVOURITE_COUNTRY_CODES_FOR_NATIONALITY.FAVOURITE_COUNTRY_CODES;

                        $scope.contact.primaryLanguage.value = LocaleService.getCurrentLocale();
                        $scope.$on('basler-language-changed', () => {
                            $scope.contact.primaryLanguage.value = BaslerCommonService.setOrResetDocumentLanguage($scope.contact.primaryLanguage.value);
                        });


                        // we only show all the input fields after gender / contact type is set
                        function showDataInputFields() {
                            return angular.isDefined($scope.contact.gender.value) ||
                                angular.isDefined($scope.contact.isCompany.value);
                        }

                        function isPerson() {
                            return $scope.contact.isCompany.value === false;
                        }

                    },
                };
            }];
    });



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/directives/MFPCreateContact.js